export default __webpack_public_path__ + "static/media/gallery37.34d64701.jpg";